import React from 'react';
import { Skeleton } from '../skeleton/index.js';
import { SYS_SIZE_FIXED_1200, SYS_SIZE_FIXED_1400, SYS_SIZE_FIXED_900 } from '@oneaudi/unified-web-alpha-common';
import {} from './index.js';
export const TextButtonSkeleton = ({ width, size = 'md', margin, 'data-testid': dataTestId, className }) => {
    return (React.createElement(Skeleton, { variant: "circular", width: width ?? '144px', height: size === 'md'
            ? SYS_SIZE_FIXED_1400
            : size === 'sm'
                ? SYS_SIZE_FIXED_1200
                : SYS_SIZE_FIXED_900, margin: margin, "data-testid": dataTestId, className: className }));
};
//# sourceMappingURL=index.skeleton.js.map